import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-full flex flex-col gap-4 text-left" }
const _hoisted_2 = { class: "w-full flex flex-wrap items-center justify-between gap-4" }
const _hoisted_3 = { class: "flex-grow min-w-[260px] sm:flex-grow-0 sm:w-2/5" }
const _hoisted_4 = { class: "flex-shrink-0" }

import { onMounted } from 'vue'
import { mdiPlus } from '@mdi/js'
import AcessManagerTab from './access.manager.tab.vue'
import FilledButton from '@/components/designSystem/Buttons/FilledButton/index.vue'
import SearchInput from '@/components/designSystem/Inputs/SearchInput.vue'
import SharePolicyModal from '@/components/designSystem/modals/share.policy.modal.vue'
import { EModals, useModalStore } from '@/pinia-store/useModalStore'
import { useHeaderStore } from '@/pinia-store/useHeaderStore'


export default /*#__PURE__*/_defineComponent({
  __name: 'Index',
  setup(__props) {

const modalStore = useModalStore()
const headerStore = useHeaderStore()

onMounted(() => {
  headerStore.setTitle('Gerenciar Acesso', 'Gerencie pessoas e grupos com acesso ao sistema')
})

const openShareModal = () => {
  modalStore.toggleModal(EModals.SHARE_POLICY)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(SearchInput, {
          width: "100%",
          label: "Buscar políticas",
          "hide-details": "",
          density: "compact",
          "data-testid": "access-manager-search-input"
        })
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(FilledButton, {
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (openShareModal()), ["stop"])),
          text: "Adicionar pessoa/grupo",
          width: "220px",
          height: "40px",
          "prepend-icon": _unref(mdiPlus),
          class: "!bg-primary30",
          "data-testid": "add-person-group-button"
        }, null, 8, ["prepend-icon"])
      ])
    ]),
    _createVNode(AcessManagerTab),
    _createVNode(SharePolicyModal)
  ]))
}
}

})